export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_farm-ledger-29/artifacts/f06esdux_Screenshot_20260616_152954_WhatsApp.jpg";

export const ROLE_LABELS = {
  admin: "Admin",
  accountant: "Accountant",
  farm_manager: "Farm Manager",
  field_worker: "Field Worker",
};

export const ROLE_OPTIONS = [
  { value: "field_worker", label: "Field Worker" },
  { value: "farm_manager", label: "Farm Manager" },
  { value: "accountant", label: "Accountant" },
];

export const ASSIGNABLE_ROLES = [
  { value: "field_worker", label: "Field Worker" },
  { value: "farm_manager", label: "Farm Manager" },
  { value: "accountant", label: "Accountant" },
  { value: "admin", label: "Admin" },
];

export const WHATSAPP_NUMBER = "2347061797432";

export const MODULE_ACCESS = {
  dashboard: ["admin", "accountant", "farm_manager", "field_worker"],
  invoices: ["admin", "accountant"],
  transactions: ["admin", "accountant"],
  payroll: ["admin", "accountant"],
  sales: ["admin", "accountant", "farm_manager", "field_worker"],
  products: ["admin", "farm_manager"],
  orders: ["admin", "accountant", "farm_manager"],
  documents: ["admin", "farm_manager"],
  reports: ["admin", "accountant"],
  vendors: ["admin", "accountant"],
  bills: ["admin", "accountant"],
  customers: ["admin", "accountant"],
  livestock: ["admin", "farm_manager", "field_worker"],
  crops: ["admin", "farm_manager", "field_worker"],
  inventory: ["admin", "accountant", "farm_manager", "field_worker"],
  employees: ["admin", "farm_manager"],
  content: ["admin", "farm_manager"],
  admin: ["admin"],
};

export const canAccess = (role, module) =>
  (MODULE_ACCESS[module] || []).includes(role);
